import { licensesForProposal, userLoader } from '../../actions/data_loaders';
import withDataLoaded from '../with_data_loaded';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import StatesHelper from '../../helpers/states_helper';
import ActionWithLoading from '../shared/action_with_loading';
import Actions from '../../actions/actions';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import NoStateLicense from '../shared/no_state_license';
import { TextField } from '@mui/material';

const StateSelector = ({ productTypeHint = 'loan' }) => {
  const user = useSelector((redux) => redux.user);
  const [productType, setProductType] = useState(productTypeHint);

  const installerProducts = user.products
    ?.filter(({ type }) => type !== 'cash')
    .sort((a, b) => {
      if (a.type === 'loan' && b.type !== 'loan') return -1;
      if (a.type !== 'loan' && b.type === 'loan') return 1;
      return a.type.localeCompare(b.type); // fallback predictable sort
    });

  const product = user?.products?.filter(({ type }) => !productType || type.includes(productType))?.[0];

  const licenses = useSelector((redux) =>
    ['SLOAN_EVERBRIGHT', 'SLOAN_ENERBANK', 'SLOAN_MOSAIC', 'SLOAN_001', 'SLOAN_003'].some(
      (e) => product.productSku === e
    )
      ? StatesHelper.validStates().map((s) => ({ state: s.abbreviation }))
      : redux?.licenseList
  );

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      state: Yup.string().required('State is Required'),
    }),
    initialValues: { cstate: null }, //licenses[0]?.state
    onSubmit: async (serverData) => await createProposal(serverData.cstate),
  });

  const [processing, setProcessing] = useState(null);
  const createProposal = async (cstate) => {
    setProcessing(!!cstate);
    try {
      await Actions.createProposal({
        cstate,
        productType: productType ?? null,
      });
    } catch (cpe) {
    } finally {
      setProcessing(null);
    }
  };

  if (!licenses || licenses?.length === 0) {
    return <NoStateLicense plural={true} />;
  }

  return (
    <div className="proposal-selector">
      <div className="proposal-options">
        {productTypeHint !== 'cash' && (
          <TextField
            id="product-type-select"
            value={productType || ''}
            onChange={(e) => setProductType(e.currentTarget.value)}
            label="Project Type"
            style={{ width: '256px' }}
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true }}
            required
            select
          >
            {installerProducts?.map(({ name, type, id }) => (
              <option key={id} value={type}>
                {name}
              </option>
            ))}
          </TextField>
        )}
        <TextField
          id="cstate"
          name="cstate"
          style={{ width: '256px' }}
          SelectProps={{
            native: true,
          }}
          onChange={(evt) => formik.setFieldValue('cstate', evt.currentTarget.value)}
          value={formik.values.cstate || ''}
          label="State"
          required
          select
          InputLabelProps={{ shrink: true }}
        >
          <option value="">Select State</option>
          {licenses
            ?.sort((a, b) => (a.state < b.state ? -1 : 1))
            ?.map(({ state }) => (
              <option id={'qa-' + state} key={state} value={state}>
                {StatesHelper.nameFromAbbr(state)}
              </option>
            ))}
        </TextField>
      </div>

      <ActionWithLoading
        processing={processing}
        disabled={!formik.values.cstate}
        classNames="generate-proposal"
        onClick={async (evt) => {
          evt.preventDefault();
          await createProposal(formik.values.cstate);
        }}
      >
        Get Started
      </ActionWithLoading>
    </div>
  );
};

const ConnectedStateSelector = withDataLoaded({
  WithData: StateSelector,
  WithoutData: () => <NoStateLicense plural={true} />,
  data: [userLoader, licensesForProposal],
  // emptyIsStillData: true,
});

export default ConnectedStateSelector;
